import { Component, inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { InfoQuestRole } from '../../../dialogs/info-quest-role/info-quest-role';
import { Downtime } from '../../../../core/services/times/downtime';

@Component({
  selector: 'app-target',
  imports: [TranslatePipe],
  templateUrl: './target.html',
  styleUrl: './target.scss'
})
export class Target implements OnInit {
  txtGoal: string = '';
  rq: any;
  readonly dialog = inject(MatDialog);
  downtime = inject(Downtime);


  ngOnInit(): void {
    this.rq = JSON.parse(sessionStorage.getItem('QuestInfo')as string);
    if(this.rq){
      this.txtGoal = this.rq.data.humman_description.goal;
    }
  }

  showText(){
    this.downtime.refreshTimer();
    const dialogConfig = new MatDialogConfig();
    dialogConfig.panelClass = 'nutri-templs';
    dialogConfig.backdropClass = 'nutri-templs-backdrop'; 
    dialogConfig.data = {text: this.rq.data.humman_description.text};
    const dialogRef = this.dialog.open(InfoQuestRole, dialogConfig);
  }

}
